import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatTableDataSource,
} from "@angular/material";
import { MedicalAppointmentWaitSearchItem } from "src/app/model/medical-appointment/medical-appointment-wait-search-item";

@Component({
  selector: "app-appointment-wait-dialog",
  templateUrl: "./appointment-wait-dialog.component.html"
})
export class AppointmentWaitDialogComponent implements OnInit {
  dataSource = new MatTableDataSource([]);
  displayedColumns: string[] = ['date', 'dateContact', 'timeContact', 'patientFullName', 'patientCelPhone', 'stateName',
    'serviceName'];
  loading: boolean;

  constructor(
    public dialogRef: MatDialogRef<AppointmentWaitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MedicalAppointmentWaitSearchItem[]
  ) {}

  async ngOnInit() {
    this.loading = true;
    this.dataSource = new MatTableDataSource(this.data);
    this.loading = false;
  }

  asociateBudget(item: MedicalAppointmentWaitSearchItem) {
    this.dialogRef.close(item);
  }

  onNoClick() {
    this.dialogRef.close(null);
  }
}
